
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"32","height":"32","rx":"16","fill":"#2DC26A"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.6571 10.1737C22.0358 10.4615 22.1126 11.0059 21.8285 11.3896L14.296 21.5658C13.8525 22.165 12.9575 22.1398 12.5474 21.5166L10.144 17.8638C9.88146 17.4647 9.9879 16.9255 10.3818 16.6594C10.7756 16.3934 11.3078 16.5012 11.5704 16.9003L13.4698 19.7871L20.4571 10.3474C20.7411 9.96372 21.2784 9.88596 21.6571 10.1737Z","fill":"white"}})])
          )
        }
      }
    